import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminarea',
  templateUrl: './adminarea.component.html',
  styleUrls: ['./adminarea.component.css']
})
export class AdminAreaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
